import { ShieldOff } from 'lucide-react'
import { signOut } from '@/lib/auth'

export function Unauthorized() {
  const handleSignOut = async () => {
    await signOut()
    window.location.href = '/login'
  }

  return (
    <div className="flex min-h-screen items-center justify-center bg-canvas px-4">
      <div className="w-full max-w-sm text-center">
        <div className="mb-4 inline-flex items-center justify-center rounded-full border border-dashed border-negative/30 bg-negative/5 p-3">
          <ShieldOff className="h-6 w-6 text-negative" strokeWidth={1.5} />
        </div>
        <h1 className="font-mono text-xs font-medium tracking-widest text-ink uppercase">
          Access Denied
        </h1>
        <p className="mt-2 font-mono text-[11px] text-ink-faint">
          Your account does not have admin privileges. Contact the system administrator if you
          believe this is an error.
        </p>
        <button
          type="button"
          onClick={handleSignOut}
          className="mt-6 rounded-md border border-dashed border-border bg-surface px-5 py-2 font-mono text-xs text-ink-muted transition-colors hover:bg-surface-alt"
        >
          Sign out and try again
        </button>
      </div>
    </div>
  )
}
